import React from 'react';

const NotFound = () => {
  return (
    <h2> Page not found</h2>
  );
};

export default NotFound;
